// extracted by mini-css-extract-plugin
export default {"container":"NavBarItem_container__GfGvN","selected":"NavBarItem_selected__Olp7z","image":"NavBarItem_image__YeBM5","name":"NavBarItem_name__cYWZ9"};